import { render, staticRenderFns } from "./KtabTag.vue?vue&type=template&id=09168ef0&scoped=true"
import script from "./KtabTag.vue?vue&type=script&lang=js"
export * from "./KtabTag.vue?vue&type=script&lang=js"
import style0 from "./KtabTag.vue?vue&type=style&index=0&id=09168ef0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09168ef0",
  null
  
)

export default component.exports